import RatingBreakdownLink from './RatingBreakdownLink'

export default RatingBreakdownLink
